import {instanceAxios} from "@/axios/axios";
import cookie from "js-cookie";

export default function getFullUserInfo() {
    return new Promise((resolve, reject) => {
        instanceAxios.get('full-user-info', {params: {userToken: cookie.get('token')}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}